import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruth7getGetScreenTruthScreensResponseSchema = jsonObject
export type tcpscreentruth7getGetScreenTruthScreensResponse = z.infer<typeof tcpscreentruth7getGetScreenTruthScreensResponseSchema>
